import { useParams } from 'react-router-dom';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { ClaimsReview } from '../ClaimsReview';

/** /claims and /claims/:claimId — the claim review workspace. */
export function ClaimsReviewPage() {
  usePageTopBar({ breadcrumb: ['Claims to review'], hideTopBar: true });
  const { claimId } = useParams();
  return <ClaimsReview {...(claimId ? { claimId } : {})} />;
}
